import React from 'react';
import { Link } from 'react-router-dom';

export default function PageTitle({ title, breadcrumbs = [], bg = '/images/background/page-title-bg.png' }) {
  return (
    <section className="mv-page-title" style={{ backgroundImage: `url(${bg})` }}>
      <div className="mv-page-title-overlay" />
      <div className="auto-container">
        <div className="mv-page-title-content">
          <h1 className="mv-page-title-text">{title}</h1>
          <ul className="mv-breadcrumb">
            <li><Link to="/">Home</Link></li>
            {breadcrumbs.map((b, i) => (
              <li key={i}>
                {b.path ? <Link to={b.path}>{b.label}</Link> : b.label}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
